import { render, staticRenderFns } from "./uiCardLayout.vue?vue&type=template&id=3f871eca&scoped=true"
import script from "./uiCardLayout.vue?vue&type=script&lang=js"
export * from "./uiCardLayout.vue?vue&type=script&lang=js"
import style0 from "./uiCardLayout.vue?vue&type=style&index=0&id=3f871eca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f871eca",
  null
  
)

export default component.exports